import { render, staticRenderFns } from "./TodoListFooter.vue?vue&type=template&id=05045214&"
import script from "./TodoListFooter.vue?vue&type=script&lang=js&"
export * from "./TodoListFooter.vue?vue&type=script&lang=js&"
import style0 from "./TodoListFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports